import { TSupportedRegistration } from '@commenda/types/src/registration/types';
import { SWRFetcher } from '@commenda/utils';
import { Country } from '@prisma/client';
import useSWR, { KeyedMutator } from 'swr';

export function useSupportedRegistrations(params: {
  businessEntityId: number;
  country?: Country;
}) {
  const queryString = new URLSearchParams();

  if ('businessEntityId' in params) {
    queryString.append('businessEntityId', params.businessEntityId.toString());
  }

  if ('country' in params) {
    queryString.append('country', params.country as string);
  }

  const {
    data,
    error,
    mutate,
  }: {
    data?: { supportedRegistrations: TSupportedRegistration[]; count: number };
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    `business-entities/registrations/supportedRegistrations?${queryString.toString()}`,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
  };
}
